export type CMBool = 'Yes' | 'No' | 'N/A';
export const CMBoolPositive: CMBool = 'Yes';
export const CMBoolNegative: CMBool = 'No';
export const CMBoolUnavailable: CMBool = 'N/A';

export const toCMBool = (value?: boolean | string, binary = true): CMBool => {
	if (!binary && isNullOrUndefined(value)) {
		return CMBoolUnavailable;
	}
	return isFalse(value) ? CMBoolNegative : CMBoolPositive;
};

export const toCMBoolDefault = (value?: boolean | string, binary = true): string =>
	toCMBool(value, binary).toString();

export const isTrue = (val?: boolean | string): boolean => !isFalsey(val);

export const isTruthy = (val?: boolean | string): boolean => isTrue(val);

export const isFalse = (val?: boolean | string): boolean =>
	val === false ||
	val === '' ||
	(val || '').toString().toLowerCase() === CMBoolNegative.toLowerCase() ||
	(val || '').toString().toLowerCase() === 'false';

export const isNull = (val?: boolean | string): boolean =>
	val === null || val === CMBoolUnavailable;
export const isUndefined = (val?: boolean | string): boolean => val === undefined;
export const isNullOrUndefined = (val?: boolean | string): boolean =>
	isNull(val) || isUndefined(val);

export const isFalsey = (val?: boolean | string): boolean => isFalse(val) || isNull(val);
